import { injectable } from 'inversify';
import { observable, computed } from 'mobx';

import { AuthenticateRequest, LoginApiService } from 'src/api';
import { ClientDataStore } from 'src/core/stores/client-data.store';
import { RouterStore } from 'src/core/stores/router.store';
import { lazyInject } from '../../ioc';

@injectable()
export class LoginStore {
    @lazyInject(ClientDataStore) clientData!: ClientDataStore;
    @lazyInject(LoginApiService) loginApi!: LoginApiService;
    @lazyInject(RouterStore) router!: RouterStore;

    @observable pwFormEmail: string | undefined;
    @observable pwFormPassword: string | undefined;
    @observable pwFormToken: string | undefined;
    @computed get pwFormFirstName() {
        return this.loginApi.checkTokenObservable
            ? this.loginApi.checkTokenObservable.firstName
            : undefined;
    }

    authenticate(req: AuthenticateRequest): Promise<void> {
        return this.loginApi.authenticate(req).then((resp) => {
            if (resp.data.success) {
                this.clientData.updateLoginData();
            } else {
                throw 'Those credentials don’t look right. Please try again.';
            }
        });
    }

    checkToken(token: string): Promise<string> {
        if (this.pwFormToken === token && this.pwFormEmail) {
            return Promise.resolve(this.pwFormEmail);
        }

        this.pwFormToken = undefined;
        this.pwFormEmail = undefined;
        this.pwFormPassword = undefined;
        return this.loginApi.checkToken({ token }, true).then(
            (result) => {
                if (!result.data.success) {
                    throw 'Invalid token';
                }
                if (!result.data.email) {
                    throw 'Invalid email for token';
                }
                this.pwFormToken = token;
                this.pwFormEmail = result.data.email;
                return this.pwFormEmail;
            },
            (err) => {
                throw 'Failed to validate token';
            }
        );
    }

    loginWithReturn = () => {
        this.loginApi.logOut();
        this.clientData.removeLoginCookie();
        this.router.history.push('/login/', { from: { pathname: this.router.location.pathname } });
    }
}
